import config from "../../../../config";
import * as modules from "./modules/";
const { vendor } = config;

const IntercomVisibilityProvider = modules[vendor]
  ? modules[vendor]
  : modules["default"];

export default IntercomVisibilityProvider;
